<pgh-modal-window>
  <div modal-close>
    <button mat-icon-button class="close-button mat-icon-button" sf-aria-label="Global_Close_Window" matDialogClose>
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div modal-title>
    <div class="mb-10" *ngIf="emailSent || memberReactivated">
      <pgh-avatar name="{{adpData.fullName}}" size="75" color="{{memberAvatarColor}}"></pgh-avatar>
      <!--<img [src]="memberAvatarUrl  || 'src/assets/images/avatars/desktop.png'"class="current-avatar" alt="{{requestorFirstName}}'s Avatar" />-->
    </div>
    <h4 class="mb-10" *ngIf="!emailSent">
      <adp-label labelKey="Account_Manage_Members_AddMember_Heading"></adp-label>
    </h4>
    <h4 class="mb-10" *ngIf="emailSent">
      <adp-label labelKey="Account_Manage_Members_AddMember_SuccessHeading"></adp-label>
    </h4>
  </div>

  <div modal-body class="mt-30 mb-30">
    <mat-error class="text-danger text-center" *ngIf="isErrorInAdd">
      <adp-label labelKey="Account_Manage_Members_AddMember_GeneralError"></adp-label>
    </mat-error>

    <form class="form" [formGroup]="addMemberForm" *ngIf="!emailSent && !memberReactivated">
      <div class="row display-flex">
        <div class="col-md-12 mb-3 name">
          <adp-input [resourceData]="getResource('FirstName')" formControlName="FirstName" (keypress)="isLetters($event)">
          </adp-input>
        </div>
        <div class=" col-md-12 mb-3 name">
          <adp-input [resourceData]="getResource('LastName')" formControlName="LastName" (keypress)="isLetters($event)">
          </adp-input>
        </div>
      </div>
      <div class="full-width email-field">
        <adp-input pgh-autofocus [resourceData]="getResource('Email')" formControlName="Email"
          class="w-100" (blur)="validateEmail()" [hideValidationMessage]="false">
        </adp-input>
        <mat-error *ngIf="validationError" class="text-danger">{{validationError}}</mat-error>
      </div>
    </form>

    <div *ngIf="emailSent" class="success-message">
      <p><adp-label [context]="adpData" labelKey="Account_Manage_Members_AddMember_ConfirmText1"></adp-label><Br>{{adpData.fullName}}!</p>
      <adp-label [context]="adpData" labelKey="Account_Manage_Members_AddMember_ConfirmText2"></adp-label>
    </div>

    <div *ngIf="memberReactivated" class="success-message">
      <p> {{adpData.fullName}}</p>
      <adp-label labelKey="Account_Manage_Members_AddMember_Reactivated"></adp-label>
    </div>
  </div>

  <div modal-footer>
    <button *ngIf="emailSent || memberReactivated" mat-flat-button color=accent type="submit" (click)="closeModal()">
      <adp-label labelKey="Global_Button_Close"></adp-label>
    </button>
    <div *ngIf="!emailSent && !memberReactivated" class="row reverse-wrap">
      <div class="col-md-6">
        <button mat-stroked-button class="border-0 fs-6" color="primary" (click)="closeModal()">
          <adp-label labelKey="Global_Button_Cancel"></adp-label>
        </button>
      </div>
      <div class="col-md-6">
        <button mat-flat-button color="accent" type="submit" 
          [gtmClick]="getViewLabel('Account_Manage_Members_AddMember_Heading')" [disabled]="!addMemberForm.valid || !validEmail || validationError"
          (click)="onSubmit()">
          <adp-label labelKey="Global_Button_Next"></adp-label>
        </button>
      </div>
    </div>
  </div>
</pgh-modal-window>
